export default __webpack_public_path__ + "static/media/cnnimage.398e9eb1.png";